import { Modal, Spin, Typography, Card, Row, Col, Tag, Divider } from "antd";
import { Link } from "react-router-dom";
import { CloseOutlined, CalendarOutlined, EnvironmentOutlined, ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";

const { Title, Text } = Typography;

export default function VerificationModal({
  isModalVisible,
  setIsModalVisible,
  selectedItemId,
  selectedItemType,
  selectedVerification,
  setSelectedVerification,
  selectedVisitas,
  setSelectedVisitas,
  loadingModal,
  generalFields,
  clienteFields,
  instalacionFields,
  visitaFields,
}) {
  return (
    <Modal
      title={null}
      visible={isModalVisible}
      onCancel={() => {
        setIsModalVisible(false);
        setSelectedVerification(null);
        setSelectedVisitas([]);
      }}
      footer={null}
      width={1000}
      closeIcon={<CloseOutlined style={{ fontSize: "18px" }} />}
      bodyStyle={{ padding: 0 }}
    >
      {loadingModal ? (
        <div style={{ padding: "60px", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      ) : (
        selectedVerification && (
          <div>
            {/* Header */}
            <div
              style={{
                background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
                padding: "32px",
                color: "white",
              }}
            >
              <Title level={2} style={{ color: "white", margin: 0, marginBottom: "8px" }}>
                {selectedVerification.ControlInterno}
              </Title>
              <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: "14px" }}>
                <CalendarOutlined style={{ marginRight: "8px" }} />
                Creado el: {moment(selectedVerification.FechaCreacion).format("DD/MM/YYYY")}
              </Text>
              <div style={{ marginTop: "16px" }}>
                <Link
                  to={`/verificaciones/${selectedItemId}`}
                  style={{
                    color: "white",
                    background: "rgba(255,255,255,0.2)",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    display: "inline-block",
                    fontWeight: "500",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.2)";
                  }}
                >
                  Ver detalles completos →
                </Link>
              </div>
            </div>

            {/* Content */}
            <div style={{ padding: "32px" }}>
              <Row gutter={[24, 24]}>
                <Col span={12}>
                  <Card
                    title="Datos Generales"
                    bordered={false}
                    headStyle={{
                      background: "#fafafa",
                      fontWeight: "600",
                      borderBottom: "2px solid #1890ff",
                    }}
                  >
                    {generalFields.map(({ key, label }) => (
                      <div key={key} style={{ marginBottom: "12px" }}>
                        <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>
                          {label}
                        </Text>
                        <Text strong style={{ fontSize: "14px" }}>
                          {key === "Monto" && selectedVerification[key]
                            ? `$${parseFloat(selectedVerification[key]).toLocaleString("es-MX", { minimumFractionDigits: 2 })}`
                            : key.includes("Fecha") && selectedVerification[key]
                            ? moment(selectedVerification[key]).format("DD/MM/YYYY")
                            : selectedVerification[key] || "N/A"}
                        </Text>
                      </div>
                    ))}
                  </Card>
                </Col>
                <Col span={12}>
                  <Card
                    title="Cliente"
                    bordered={false}
                    headStyle={{
                      background: "#fafafa",
                      fontWeight: "600",
                      borderBottom: "2px solid #1890ff",
                    }}
                  >
                    {clienteFields.map(({ key, label }) => (
                      <div key={key} style={{ marginBottom: "12px" }}>
                        <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>
                          {label}
                        </Text>
                        <Text strong style={{ fontSize: "14px" }}>
                          {selectedVerification[key] || "N/A"}
                        </Text>
                      </div>
                    ))}
                  </Card>
                </Col>
              </Row>

              <Row gutter={[24, 24]} style={{ marginTop: "24px" }}>
                <Col span={12}>
                  <Card
                    title={
                      <>
                        <EnvironmentOutlined /> Ubicación
                      </>
                    }
                    bordered={false}
                    headStyle={{
                      background: "#fafafa",
                      fontWeight: "600",
                      borderBottom: "2px solid #52c41a",
                    }}
                  >
                    <Text style={{ fontSize: "14px" }}>
                      {selectedVerification.NombreCalle} {selectedVerification.NumeroOficial}, {selectedVerification.ColoniaOAsentamiento},{" "}
                      {selectedVerification.Municipio}, {selectedVerification.Estado}
                    </Text>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card
                    title="Instalación"
                    bordered={false}
                    headStyle={{
                      background: "#fafafa",
                      fontWeight: "600",
                      borderBottom: "2px solid #faad14",
                    }}
                  >
                    {instalacionFields.map(({ key, label, suffix }) => (
                      <div key={key} style={{ marginBottom: "12px" }}>
                        <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>
                          {label}
                        </Text>
                        <Text strong style={{ fontSize: "14px" }}>
                          {selectedVerification[key] ? `${selectedVerification[key]} ${suffix}` : "N/A"}
                        </Text>
                      </div>
                    ))}
                  </Card>
                </Col>
              </Row>

              {selectedVisitas.length > 0 && (
                <Card
                  title={
                    <>
                      <ClockCircleOutlined /> Visita(s) Programada(s)
                    </>
                  }
                  style={{ marginTop: "24px" }}
                  bordered={false}
                  headStyle={{
                    background: "#fafafa",
                    fontWeight: "600",
                    borderBottom: "2px solid #722ed1",
                  }}
                >
                  {selectedVisitas.map((visita, index) => (
                    <div key={index}>
                      {index > 0 && <Divider />}
                      <Tag color="purple" style={{ marginBottom: "12px" }}>
                        Visita {index + 1}
                      </Tag>
                      <Row gutter={[16, 12]}>
                        {visitaFields.map(({ key, label }) => (
                          <Col span={8} key={key}>
                            <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>
                              {label}
                            </Text>
                            <Text strong style={{ fontSize: "14px" }}>
                              {key.includes("Fecha") && visita[key] ? moment(visita[key]).format("DD/MM/YYYY") : visita[key] || "N/A"}
                            </Text>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ))}
                </Card>
              )}
            </div>
          </div>
        )
      )}
    </Modal>
  );
}
